export default {
    control: {
        backgroundColor: '#fdf6d9',
        borderRadius: '8px',
        padding: '8.5px 14px',
    },
    input: {
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: '8px',
        boxShadow: 'none',
        fontSize: '14px',
        margin: 0,
        outline: 'none',
        padding: '8.5px 14px',
    },
    suggestions: {
        list: {
            backgroundColor: 'transparent',
            border: '1px solid rgba(0,0,0,0.15)',
            fontSize: '14px',
            height: '100px',
            overflowY: 'scroll',
            scrollbarWidth: 'thin',
        },
        item: {
            borderBottom: '1px solid rgba(0,0,0,0.15)',
            color: '#000',
            padding: '5px 15px',
            '&focused': {
                backgroundColor: '#cee4e5',
            },
        },
    },
};
